import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", size = 40, showText = true, textClass = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="brand-logo-link">
      <img src="/logo.png" alt="BullsEye Capital" style={{ height: size }} className="w-auto select-none" draggable="false" />
      {showText && (
        <span className={`h-display text-lg leading-none tracking-wide ${textClass}`}>
          <span className="gold-text">BULLSEYE</span>{" "}
          <span className="text-white/90 font-light">CAPITAL</span>
        </span>
      )}
    </Link>
  );
}
